export default "__VITE_ASSET__e4010ae3__"